import t from"./validator.esm.js";function e(){return new t(arguments.length>0&&void 0!==arguments[0]?arguments[0]:{})}export{e as default};
